<template>
  <div>
    <h2 class="h1-responsive font-weight-bold  mb-3 text-center">爱尔兰移民</h2>

    <mdb-container>
      <mdb-tabs
        :active="0"
        tabs
        color="#purple lighten-1"
        card
        class="mb-5"
        :links="[
      { text: '爱尔兰捐赠移民',slot:'IrelandJZ-slot' },
      { text: '爱尔兰投资移民',slot:'IrelandTZ-slot' },
]"
      >

        <template :slot="'IrelandJZ-slot'">
          <mdb-container>
            <mdb-jumbotron class="text-center hoverable">
              <mdb-row v-animateOnScroll="{animation: 'zoomIn', delay: 0, position: 0}">
                <mdb-col md="4" offsetMd="1" class="m-0 mb-3">
                  <mdb-view class="rounded z-depth-2" :src="require('../assets/images/ie/2.jpg')"
                            alt="" style="height: 180px;">
                    <a>
                      <mdb-mask waves overlay="white-slight"/>
                    </a>
                  </mdb-view>

                </mdb-col>

                <mdb-col md="7" class="text-md-left ml-3">

                  <h4 class="h4 mb-4">爱尔兰捐赠移民</h4>
                  <p class="font-weight-normal">门槛低，无语言要求、无面试；<br/>
                    含金量高，先获批再捐款；<br/>
                    周期短，审批4至6个月；<br/>
                  </p>
                  <mdb-btn outline="lightgreen" darkWaves @click.native="showIrelandJZModal = true">了解详情</mdb-btn>
                </mdb-col>
              </mdb-row>
            </mdb-jumbotron>


          </mdb-container>

        </template>

        <template :slot="'IrelandTZ-slot'">
          <mdb-container>
            <mdb-jumbotron class="text-center hoverable">
              <mdb-row>
                <mdb-col md="4" offsetMd="1" class="m-0 mb-3">
                  <mdb-view class="rounded z-depth-2" :src="require('../assets/images/ie/3-1.jpg')"
                            alt="" style="height: 180px;">
                    <a>
                      <mdb-mask waves overlay="white-slight"/>
                    </a>
                  </mdb-view>

                </mdb-col>

                <mdb-col md="7" class="text-md-left ml-3">

                  <h4 class="h4 mb-4">爱尔兰投资移民</h4>
                  <p class="font-weight-normal">门槛低、无语言要求和管理背景要求；<br/>
                    更放心，投资100万欧元到政府项目 ；<br/>
                    更便利，与英国一衣带水，西欧福利大国爱尔兰 ；<br/>
                  </p>
                  <mdb-btn outline="lightgreen" darkWaves @click.native="showIrelandTZModal = true">了解详情</mdb-btn>
                </mdb-col>
              </mdb-row>
            </mdb-jumbotron>

          </mdb-container>
        </template>


      </mdb-tabs>

    </mdb-container>


    <mdb-modal :show="showIrelandJZModal" @close="showIrelandJZModal = false" class="text-justify text-monospace" scrollable>
      <mdb-modal-header>
        <mdb-modal-title>爱尔兰捐赠移民</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <h5>项目介绍：</h5>
        该捐赠是属于公益性的慈善捐助，捐赠完成后无后顾之忧。向艺术、体育、健康、文化或教育等公益领域的项目捐赠50万欧元。如果有五个或五个以上的申请人参与同一个项目，每个申请可减免10万欧的捐赠款。

        <h5>申请条件：</h5>
        1、主申请人18周岁以上
        2、子女24周岁以下
        3、拥有不低于50万欧元的现金
        4、拥有不低于200万欧元的资产（包含50万欧元的现金）

        <h5>项目优势：</h5>
        1、门槛低，无语言要求、无面试、无体检、无移民监
        2、含金量高，先获批再捐款、全家拿永居
        3、周期短，审批4至6个月
        4、免费教育，小学至高中免费公立教育
        5、多重身份，入籍享爱尔兰+英国+欧盟三重身份


        <h5>申请流程：</h5>
        1、评估/签约
        2、准备投资款及申请文件
        3、递交正式申请文件
        4、完成捐款
        5、获得2年居留身份(Stamp4)
        6、2年后续签3年的居留身份
        7、3年后续签每次5年的居留身份
        8、如符合居住要求，可申请入籍

      </mdb-modal-body>
      <mdb-modal-footer>
        <mdb-btn class="mx-auto" outline="secondary" @click.native="showIrelandJZModal = false">关闭</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>

    <mdb-modal :show="showIrelandTZModal" @close="showIrelandTZModal = false" class="text-justify text-monospace" scrollable>
      <mdb-modal-header>
        <mdb-modal-title>爱尔兰投资移民</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <h5>项目介绍：</h5>
        爱尔兰政府在2013年7月修正移民法案，非欧盟国家公民在爱尔兰境内投资不低于100万欧元就可获得居留许可。此项投资的意义在于为爱尔兰当地社会增加就业，吸引有自己商业模式或商业战略并把爱尔兰当作理想投资目的地的企业家或个人。企业家投资移民方式十分适合那些有自己的商业模式或商业战略并且把爱尔兰当作理想投资目的地的企业家或个人。

        申请条件
        1、主申请人年满18岁
        2、无犯罪记录
        3、申请人（夫妻）名下拥有200万欧元资产并且拥有可用于投资的100万欧元现金
        4、投资100万欧至企业
        5、需要购买爱尔兰医疗保险

        <h5>项目优势:</h5>
        1、门槛低
        无语言要求、无管理背景要求、 无移民监
        2、更放心
        投资100万欧元到政府项目
        3、更便利
        与英国一衣带水，西欧福利大国爱尔兰，唾手可得

        <h5>申请流程：</h5>
        1、评估/签约
        2、准备投资款及申请文件
        3、递交正式申请文件
        4、收到原则批准
        5、完成投资
        6、获得2年居留身份(Stamp4)
        7、2年后续签3年的居留身份
        8、3年后续签每次5年的居留身份
        9、如符合居住要求，可申请入籍


      </mdb-modal-body>
      <mdb-modal-footer>
        <mdb-btn class="mx-auto" outline="secondary" @click.native="showIrelandTZModal = false">关闭</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
  </div>


</template>

<script>
  import {mdbScrollSpy, animateOnScroll} from "mdbvue";

  export default {
    name: "HomeIe",
    data() {
      return {
        showIrelandJZModal: false,
        showIrelandTZModal: false,
      }
    },
    directives: {mdbScrollSpy, animateOnScroll}
  }
</script>
